import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { getIsPrescriptionStepValid, getPrescriptionType } from '../../selectors.js';
import { PrescriptionFormStepContainer } from '../../../../Configurator/steps/PrescriptionFormStep/PrescriptionFormStepContainer.js';

const prescriptionFormStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionFormStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === 'NewPrescription' ? 'sub-step' : 'hidden'
    )
};

export { prescriptionFormStepBase };
//# sourceMappingURL=prescription-form.js.map
